import { FormControl } from '@angular/forms';

import { isValidPhone } from '@brazilian-utils/brazilian-utils';

/**
 * ### Phone number Validator
 *
 * Realizes the Phone number validation.
 */
export class PhoneValidator {
  /**
   * Verify if phone number is valid
   * @param control Form control object.
   * @returns Any return.
   */
  static isValid(control: FormControl) {
    const value: string = control.value ? control.value.toString() : '';
    const phoneNumber = value.replace(/\D/g, '');

    // return if is valid
    if (isValidPhone(phoneNumber) || phoneNumber === '') {
      return null;
    }

    // return if is invalid
    return { invalidPhone: true };
  }
}
